import { Divider } from '@mui/material'

import StickyHeader from '@/components/StickyHeader'
import { StoreAddressWithQuery } from '@/components/stores/StoreAddressWithQuery'

import { Filter, FilterBar } from '../../components/FilterBar'

type Props = {
  storeId: string
  filters: Filter[]
}

const CoolerDetailHeader: React.FC<Props> = ({ storeId, filters }) => {
  return (
    <StickyHeader>
      <StoreAddressWithQuery id={storeId} />
      <FilterBar filters={filters} />
      <Divider />
    </StickyHeader>
  )
}

export default CoolerDetailHeader
